export default __webpack_public_path__ + "static/media/q2_01.74440946.png";